import styled from "styled-components";

export const CustomChartContainer = styled.div`
  border-radius: 11.674px;
  border: 0.584px solid #eaecf0;
  background: #fff;
  box-shadow: 0px 0.5837px 1.1674px 0px rgba(16, 24, 40, 0.06),
    0px 0.5837px 1.75111px 0px rgba(16, 24, 40, 0.1);

  padding: 20px 8px;
  max-width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CustomChartHeader = styled.div`
  display: flex;
  padding-left: 8px;
  align-items: center;
  gap: 4.67px;
  min-height: 42px;
`;

export const CustomChartTitle = styled.div`
  color: var(--cinza-600, #667085);
  font-family: Work Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 14.009px; /* 70.044% */
  flex: 1 0 0;
`;

export const ChartWrapper = styled.div`
  /* margin-bottom: 3rem; */
  .tooltip_default {
    display: flex;
    /* width: 98px;
    height: 43px; */
    padding: 8px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 4px;
    border: 1px solid var(--cinza-200, #d8dadf);
    background: var(--Branco, #fff);
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.15);
    gap: 12px;
    text-align: center;

    & .monthName {
      color: #2e2a2a;
      text-align: center;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 7.004px; /* 58.37% */
      letter-spacing: 0.24px;
      width: 100%;
    }

    & .row {
      display: flex;
      gap: 8px;
      justify-content: center;
      align-items: center;
    }

    & .color {
      display: block;
      width: 11px;
      height: 11px;
      border-radius: 3px;
      background: #6ee7b7;
    }

    & .value {
      color: #2e2a2a;
      text-align: center;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      
      letter-spacing: 0.28px;
    }

    &:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: black transparent transparent transparent;
    }
  }
`;